// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-title[data-v-4206556d]:first-child {\n  text-transform: uppercase;\n}\n.header-title[data-v-4206556d]:last-child {\n  text-transform: uppercase;\n}\n.pm-index[data-v-4206556d] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
